import classes from "./BoxesContainer.module.css";
import { MuuriComponent } from "muuri-react";
import "./BoxesContainer.css";
import Box from "../../../TEMPLATE/components/box/Box";
import { UvUrl } from "../../hardCodeData/DATA";
import Meteor from "../../../TEMPLATE/components/categories/meteo/Meteor";
import Meshlium from "../../../TEMPLATE/components/categories/meshlium/Meshlium";
import UvIndexes from "../../../TEMPLATE/components/categories/uv/UvIndexes";
import Weather from "../../../TEMPLATE/components/categories/weather/Weather";
import CustomCategoryUniversity from "../categories/CustomCategoryUniversity";
import LanguageContext from "../../../TEMPLATE/hooks/language-context";
import MapPOIS from "../../../TEMPLATE/components/categories/mapPOIS/MapPOIS";
import CustomCategoryDiav from "../categories/CustomCategoryDiav";
import Applicants from "../categories/Applicants";
import IanosEnergy from "../categories/IanosEnergy";
import Parking from "../categories/Parking";
import MapPOISAMEA from "../../../TEMPLATE/components/categories/MapPOISAMEA/MapPOISAMEA";
import WelcomeMessage from "../../../TEMPLATE/components/Home/Welcome/WelcomeMessage";
import styled from "styled-components";
import ThreeDimensions from "../categories/ThreeDimensions";

const maxEntitiesLargeBox = 9;
const maxEntitiesMediumBox = 2;

const options = {
  dragSortHeuristics: {
    sortInterval: 0,
  },
  layoutDuration: 400,
  dragRelease: {
    duration: 400,
    easing: "ease-out",
  },
  dragEnabled: true,
  dragStartPredicate: function (item, hammerEvent) {
    if (hammerEvent.target.matches("#draggable")) {
      return true;
    }
    return false;
    // distance: 0,
    // delay: 500,
  },
  dragContainer: document.body,
  // The placeholder of an item that is being dragged.
  dragPlaceholder: {
    enabled: true,
    createElement: function (item) {
      // The element will have the Css class ".muuri-item-placeholder".
      return item.getElement().cloneNode(true);
    },
  },
};
const BoxesContainer = () => {
  return (
    <BoxesWrapper>
      <WelcomeWrapper>
        <WelcomeMessage />
      </WelcomeWrapper>
      <MuuriComponent {...options}>
        {/* <Box className={classes.large} typeId="1">
         <Meteor
            maxEntities={maxEntitiesLargeBox}
            typeId="1"
            title={t("ΠΕΡΙΒΑΛΛΟΝΤΙΚΑ ΔΕΔΟΜΕΝΑ")}
            showSubTitle={true}
          />
        </Box> */}

        <Box className={classes.large} typeId="5">
          <Meteor
            typeId="5"
            title="ΜΕΤΕΩΡΟΛΟΓΙΚΑ ΔΕΔΟΜΕΝΑ"
            showSubTitle={true}
          />
        </Box>

        {/* <Box className={[classes.map_box, classes.bgColor].join(" ")} typeId="8">
          <MapPOIS typeId="8" title="ΔΙΑΧ/ΣΗ ΣΤΟΛΟΥ" />
        </Box> */}

        <Box className={classes.map_box} typeId="31">
          <MapPOIS typeId="31" title="ΠΙΝΑΚΙΔΕΣ ΠΛΗΡΟΦΟΡΗΣΗΣ" />
        </Box>

        <Box className={`${classes.map_box} ${classes.diadromes}`} typeId="122">
          <MapPOIS typeId="122" title="ΥΠΟΔΟΜΕΣ ΑΜΕΑ" />
        </Box>

        {/* <Box className={classes.map_box} typeId="29">
          <MapPOIS typeId="29" title="ΗΛΕΚΤΡΟΦΟΡΤΙΣΤΕΣ" />
        </Box> */}

        <Box
          className={[classes.medium, classes.weatherBox].join(" ")}
          title="ΠΕΡΙΒΑΛΛΟΝΤΙΚΑ"
        >
          <Weather />
        </Box>

        {/* <Box className={classes.medium} typeId="1">
          <Meteor
            maxEntities={maxEntitiesLargeBox}
            typeId="1"
            title={t("ΠΕΡΙΒΑΛΛΟΝΤΙΚΑ ΔΕΔΟΜΕΝΑ")}
            showSubTitle={true}
            group={"3"}
          />
        </Box> */}

        {/* <Box className={classes.map_box} typeId="4">
         <MapPOIS typeId="4" title="WIFI HOTSPOTS" />
        </Box> */}

        {/* <Box className={[classes.large, classes.bgGreenColor].join(" ")} typeId="1">
          <Meteor
            maxEntities={maxEntitiesLargeBox}
            typeId="1"
            title={t("ΠΕΡΙΒΑΛΛΟΝΤΙΚΑ ΔΕΔΟΜΕΝΑ")}
            showSubTitle={false}
            group={"1"}
          />
        </Box> */}

        {/* <Box className={classes.large} typeId="5">
          <Meteor
            maxEntities={maxEntitiesLargeBox}
            typeId="5"
            title={t("ΜΕΤΕΩΡΟΛΟΓΙΚΑ ΔΕΔΟΜΕΝΑ")}
            showSubTitle={false}
          />
        </Box> */}

        {/* <Box className={classes.large} typeId="1">
          <Meteor
            maxEntities={maxEntitiesLargeBox}
            typeId="1"
            title={t("ΠΕΡΙΒΑΛΛΟΝΤΙΚΑ ΔΕΔΟΜΕΝΑ")}
            showSubTitle={true}
            group={"1"}
          />
        </Box> */}
        {/* <Box className={classes.large} typeId="5" >
          <Meteor
            maxEntities={maxEntitiesLargeBox}
            typeId="5"
            title={t("ΠΕΡΙΒΑΛΛΟΝΤΙΚΑ ΔΕΔΟΜΕΝΑ")}
            showSubTitle={false}
          />
        </Box> */}

        {/* <Box className={classes.map_box} typeId="9">
          <MapPOIS typeId="9" title="ΚΑΔΟΙ" />
        </Box> */}

        {/* <Box className={classes.map_box} typeId="8" title="ΚΙΝΗΤΙΚΟΤΗΤΑ">
         <MapPOIS typeId="8" title="ΔΙΑΧ/ΣΗ ΣΤΟΛΟΥ" />
        </Box> */}
        {/* <Box className={classes.map_box} typeId="8">
         <MapPOIS typeId="8" title="ΔΙΑΧ/ΣΗ ΣΤΟΛΟΥ" />
        </Box> */}

        {/* <Box className={`${classes.large} ${classes.ianosEnergy}`} typeId="12">
         <IanosEnergy />
        </Box> */}

        {/* <Box className={classes.map_box} typeId="4">
          <MapPOIS typeId="4" title="WIFI HOTSPOTS" />
        </Box> */}

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes indexName="ΔΕΙΚΤΗΣ UV" typeId="5" />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes indexName="ΔΕΙΚΤΗΣ ΔΥΣΦΟΡΙΑΣ" typeId="5" />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes indexName="ΔΕΙΚΤΗΣ ΥΓΡΑΣΙΑΣ" typeId="5" />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes indexName="ΠΟΙΟΤΗΤΑ ΑΕΡΑ" typeId="5" />
        </Box>

        {/* <Box className={[classes.medium, classes.weatherBox].join(" ")}>
          <Weather />
        </Box> */}

        {/* Diavouleuseis */}
        <Box
          className={[classes.medium, classes.three_d].join(" ")}
          title="3D ΑΝΑΠΑΡΑΣΤΑΣΕΙΣ"
        >
          <ThreeDimensions />
        </Box>

        {/* Applicants */}
        {/* <Box
          className={[classes.medium, classes.applicants].join(" ")}
          title="ΕΞΥΠΗΡΕΤΗΣΗ"
        >
          <Applicants />
        </Box> */}

        {/* <Box
          className={`${classes.medium} ${classes.parking}`}
          title={"Παρκινγ"}
        >
          <Parking id={0} typeId={"24"} />
        </Box> */}
      </MuuriComponent>
    </BoxesWrapper>
  );
};

export default BoxesContainer;

const BoxesWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  margin: 0 auto;

  @media only screen and (max-width: 908px) {
    width: unset;
    display: block;
  }

  scrollbar-color: #373b40 #1a1d21;
  scrollbar-width: thin;
`;

const WelcomeWrapper = styled.div`
  display: none;

  @media only screen and (max-width: 908px) {
    display: block;
  }
`;
